// extracted by mini-css-extract-plugin
export default {"spinner":"styles_spinner__hDr5T","spin":"styles_spin__MwsFO"};